import React from "react";

import Layout from "../components/Layout";
import SEO from "../components/SEO";
import me from "../images/me.png";
import { Link } from "gatsby";

function AboutPage() {
  return (
    <Layout>
      <SEO title="About"
      />

      <section className="w-full px-4 sm:max-w-6xl mx-auto py-16">
        <h1 className="text-3xl leading-tight font-extrabold text-gray-900 sm:text-4xl text-center">About Me</h1>
        <img className="my-8 h-64 object-cover mx-auto rounded-full" src={me} alt="my-pic" />
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          Hello! I'm Bilal. I like to build things. And I've built a variety of <Link className="text-indigo-600 font-medium" to="/templates">them</Link> 
          {' '} over my career as a builder.
        </p>  
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          I am at my happiest in the thick of the creation process, going from ideation to execution at blinding speed. As you can see, I've been busy this year.
          And I learned a thing or two about developing and marketing products. I wanted to try and help people going through the same journey as me. 
        </p>  
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
         One of the places all of us get stuck on is the landing page so 
         it was a natural thing to focus on. 
        </p>  
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          There is no one right way to build a landing page or website but using my process I have been able to move fast while building robust and scalable products.
        </p>  
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          And if you want to get a jump ahead on this process, you can get started <Link className="text-indigo-600 font-medium" to="/start">here</Link>.
        </p>  
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          Need something a bit more custom? I got you. Shoot me a <Link className="text-indigo-600 font-medium" to="/contact">message</Link> and we can work out a project specifically tailored for your needs.
        </p>
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          Looking forward to hearing from you. <span role="img" aria-label="smiling-emoji">😀</span>
        </p>                                    
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          Bilal
        </p>                                                                                                
      </section>
    </Layout>
  );
}

export default AboutPage;
